<template>
  <modal
    :visible="value"
    class="payment-methods-modal"
    @on-close="$emit('input', false)"
  >
    <ui-loader
      v-if="loading"
      size="64"
      class="payment-methods-modal__loader"
    />

    <div class="payment-methods-modal__title">
      Выберите способ оплаты
    </div>

    <div class="payment-methods-modal__wrapper">
      <payment-method
        v-for="method in paymentMethods"
        :key="method.value"
        :info="method"
        :disabled="loading"
        @click.native="$emit('select', method)"
      />
    </div>
  </modal>
</template>

<script>
import PaymentMethod from './payment-method.vue';

export default {
  name: 'payment-methods-modal',

  components: { PaymentMethod },

  props: {
    value: {
      type: Boolean,
      default: false,
    },

    paymentMethods: {
      type: Array,
      required: true,
    },

    loading: {
      type: Boolean,
      default: false,
    }
  },
};
</script>

<style lang="scss">
.payment-methods-modal {
  &__title {
    font-size: 16px;
    line-height: 24px;
    font-weight: bold;
  }

  &__wrapper {
    margin-top: 12px;
  }

  & > .modal-content {
    padding: 12px 16px 16px;
  }

  &__loader {
    position: absolute;
    top: 50%;
    left: 50%;
    color: $blue;
    transform: translate(-50%, -50%);
  }
}

@include breakpoint("tablet") {
  .payment-methods-modal {
    &__wrapper {
      margin-top: 24px;
      padding: 0 48px;
    }

    & > .modal-content {
      width: 576px;
      padding: 24px 24px 72px;
    }
  }
}
</style>

